import * as React from "react";
import { usePresence } from "./presence-context";

// Bottom-left nudge that appears only when someone else is here (Here > 1).
export default function ChatHint({
  quietMode = false,
}: {
  quietMode: boolean;
}) {
  const { myself, otherUsers, synced } = usePresence((state) => ({
    myself: state.myself,
    otherUsers: state.otherUsers,
    synced: state.synced,
  }));

  if (!synced) return null;

  const count = myself ? otherUsers.size + 1 : otherUsers.size;
  if (count <= 1) return null;

  // Hide on touch / mobile for now — no physical keyboard to press "/".
  // (Click-to-chat may come later.)
  if (
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(pointer: coarse)").matches
  ) {
    return null;
  }

  const styles: React.CSSProperties = {
    boxSizing: "border-box",
    paddingTop: "8px",
    paddingBottom: "8px",
    height: "calc(1.5rem + 16px)", // 40px total - matches PresenceCounter
    position: "fixed",
    bottom: "12px",
    left: "18px",
    borderRadius: "24px",
    border: "1px solid rgba(168, 162, 158, 1)", // stone-400
    color: "rgba(168, 162, 158, 1)", // stone-400
    display: "flex",
    alignItems: "center",
    fontFamily:
      'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontSize: "0.875rem", // 14px
    fontWeight: 500,
    paddingLeft: "calc(0.5rem + 8px)",
    paddingRight: "calc(0.5rem + 8px)",
    pointerEvents: "none" as const,
    userSelect: "none" as const,
    visibility: quietMode ? ("hidden" as const) : ("visible" as const),
    zIndex: 1000,
  };

  return (
    <div style={styles}>
      hit&nbsp;<kbd style={{ fontFamily: "inherit", fontWeight: 600 }}>/</kbd>
      &nbsp;to chat
    </div>
  );
}
